import './style.css'; 
import Component from "./Component.vue";

export default Component; 

export {

  Component,
}